import React, { ChangeEvent, useCallback } from 'react';
import { FieldRenderProps } from 'react-final-form';
import Input from 'components/Input/Input.component';
import utils from 'utils';

export type InputFieldProps = FieldRenderProps<string, HTMLElement>;

const InputField: React.FC<InputFieldProps> = (props) => {
  const {
    className,
    input: { onChange, value, ...inputRest },
    meta: { error, touched },
    onlyNumbers = false,
    isPhoneNumber = false,
    ...rest
  } = props;

  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const {
        target: { value },
      } = event;

      if (onlyNumbers && value && !/^(\d){0,}$/.test(value)) {
        return onChange(value.replace(/[^\d]/g, ''));
      }

      if (isPhoneNumber && value) {
        return onChange(utils.normalizePhone(value).trim());
      }

      onChange(value);
    },
    [isPhoneNumber, onChange, onlyNumbers],
  );

  return (
    <Input
      wrapperClassName={className}
      error={error && touched ? error : ''}
      {...rest}
      {...inputRest}
      onChange={handleOnChange}
      value={value}
    />
  );
};

export default InputField;
